exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".sql-error{background-color:rgba(127,0,0,.5);white-space:pre-wrap}", ""]);

// exports
